
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Punetomahabaleshwer() {



    const cardData =
    {
        keyword: 'Pune to Mahabaleshwar Cabs   ',
        heading: 'Morya Cabs:  Pune to Mahabaleshwar Cabs   ',
        headingDescription: 'Planning a trip from Pune to Mahabaleshwar? Morya Cabs offers reliable, affordable, and comfortable taxi services for a stress-free journey. Whether you’re traveling for a weekend getaway, family vacation, or adventure trip, our well-maintained cabs and professional drivers ensure a smooth ride. Book your cab online and enjoy a scenic drive through the Western Ghats at competitive rates.',

        top: 'Top Places to Visit in Mahabaleshwar with Morya Cabs',

        topPlaces: [
            {
                "title": "Venna Lake",
                "description": "A popular tourist attraction, Venna Lake offers boating and horse riding activities. Enjoy a peaceful time by the lake with a comfortable ride from Morya Cabs."
            },
            {
                "title": "Pratapgad Fort",
                "description": "A historic fort built by Chhatrapati Shivaji Maharaj, Pratapgad Fort offers stunning views and rich history. Travel conveniently with Morya Cabs for an enriching experience."
            },
            {
                "title": "Arthur’s Seat",
                "description": "Known as the 'Queen of Points,' Arthur’s Seat provides breathtaking views of the valleys and the Savitri River. Book a cab with Morya Cabs for a hassle-free visit."
            },
            {
                "title": "Lingmala Waterfall",
                "description": "A mesmerizing waterfall offering a perfect escape into nature, Lingmala Waterfall is a must-visit spot. Enjoy a smooth ride to this picturesque location with Morya Cabs."
            },
            {
                "title": "Mapro Garden",
                "description": "Famous for its strawberry products, Mapro Garden is a great place to enjoy fresh juices, chocolates, and shakes. Travel comfortably with Morya Cabs for a delightful experience."
            },
            {
                "title": "Elephant’s Head Point",
                "description": "A viewpoint resembling an elephant’s head, this location offers panoramic views of the surrounding hills. Book your ride with Morya Cabs for a memorable trip."
            },
            {
                "title": "Wilson Point",
                "description": "The highest point in Mahabaleshwar, Wilson Point is perfect for sunrise lovers. Reach this breathtaking spot effortlessly with Morya Cabs."
            },
            {
                "title": "Panchgani",
                "description": "A nearby hill station, Panchgani is famous for its lush green landscapes and Table Land. Morya Cabs provides a comfortable ride to explore this beautiful town."
            },
            {
                "title": "Mahabaleshwar Temple",
                "description": "A revered pilgrimage site dedicated to Lord Shiva, the Mahabaleshwar Temple is a must-visit for spiritual seekers. Travel safely and conveniently with Morya Cabs."
            },
            {
                "title": "Connaught Peak",
                "description": "Offering panoramic views of Mahabaleshwar and nearby valleys, Connaught Peak is a paradise for photographers and nature lovers. Experience a hassle-free trip with Morya Cabs."
            }
        ],



"services": [
    {
        "name": "Pune to Mahabaleshwar Cab Booking",
        "description": "Morya Cab offers easy and convenient Pune to Mahabaleshwar cab booking services. Whether you are planning a short trip or a long getaway, we provide reliable and comfortable rides to Mahabaleshwar. Book your cab with us today for a smooth and enjoyable journey."
    },
    {
        "name": "Taxi from Pune to Mahabaleshwar",
        "description": "Looking for a taxi from Pune to Mahabaleshwar? Morya Cab provides a hassle-free taxi service that ensures a safe and comfortable journey. With experienced drivers and well-maintained vehicles, we guarantee you will have a pleasant ride to Mahabaleshwar."
    },
    {
        "name": "Pune to Mahabaleshwar Car Hire",
        "description": "If you prefer to hire a car for your trip to Mahabaleshwar, Morya Cab offers a variety of options. Our flexible car hire services allow you to choose the right vehicle according to your needs and enjoy a customized journey from Pune to Mahabaleshwar."
    },
    {
        "name": "Pune to Mahabaleshwar Taxi Service",
        "description": "Morya Cab’s Pune to Mahabaleshwar taxi service is known for its punctuality and comfort. Whether you're visiting for sightseeing or a peaceful retreat, our taxis will take you to Mahabaleshwar in comfort and style."
    },
    {
        "name": "Pune to Mahabaleshwar Cab Rental",
        "description": "For those looking to rent a cab from Pune to Mahabaleshwar, Morya Cab offers affordable rental options. You can book your cab with us for a day, a weekend, or for a longer stay, with the flexibility to travel at your own pace."
    },
    {
        "name": "Pune to Mahabaleshwar Elphinstone Point Car",
        "description": "Elphinstone Point is one of the must-see attractions in Mahabaleshwar. Morya Cab offers specialized services to take you there from Pune. Book a cab with us for a comfortable and scenic ride to Elphinstone Point and other nearby attractions."
    },
    {
        "name": "Pune to Mahabaleshwar Pratapgad Fort Car",
        "description": "Pratapgad Fort is a historic landmark in Mahabaleshwar. Morya Cab provides reliable transportation to Pratapgad Fort from Pune, ensuring that you enjoy the scenic drive and reach the fort with ease."
    },
    {
        "name": "Pune to Mahabaleshwar Cab Price",
        "description": "At Morya Cab, we offer competitive pricing for your Pune to Mahabaleshwar trip. Our cab fare is transparent and affordable, and we make sure there are no hidden charges. Get in touch with us for an accurate estimate for your journey."
    },
    {
        "name": "Pune to Mahabaleshwar 2 Days Taxi Fare",
        "description": "Planning to stay for two days in Mahabaleshwar? Morya Cab offers a 2-day taxi service with a special fare package. Enjoy a relaxed trip with your own cab, customized according to your travel plans."
    },
    {
        "name": "Book Cab from Pune to Mahabaleshwar",
        "description": "Booking a cab from Pune to Mahabaleshwar is simple with Morya Cab. Whether you want to book online or over the phone, we ensure an easy and convenient process. Your journey to Mahabaleshwar is just a call away!"
    },
    {
        "name": "Pune to Mahabaleshwar Cabs",
        "description": "Morya Cab offers comfortable and reliable cabs for your trip from Pune to Mahabaleshwar. Choose from a range of vehicles to suit your preferences and enjoy a comfortable journey with professional drivers."
    },
    {
        "name": "Pune to Mahabaleshwar Taxi",
        "description": "If you're looking for a taxi from Pune to Mahabaleshwar, Morya Cab is your go-to option. Our professional drivers and well-maintained taxis guarantee a smooth and safe ride, making your trip enjoyable from start to finish."
    },
    {
        "name": "Pune to Mahabaleshwar Cab Price",
        "description": "Morya Cab offers competitive and transparent pricing for your Pune to Mahabaleshwar trip. We provide detailed information on cab fares so you can plan your trip with peace of mind. No hidden fees, just great service."
    },
    {
        "name": "Pune to Mahabaleshwar Distance by Taxi Fare",
        "description": "If you're wondering about the distance from Pune to Mahabaleshwar, it's approximately 120 kilometers. Morya Cab offers the most affordable and reliable taxi fares for the journey, ensuring a comfortable ride to Mahabaleshwar."
    },
    {
        "name": "Pune to Mahabaleshwar Cab for 2 Days",
        "description": "For those planning a longer trip, Morya Cab offers a two-day cab service to Mahabaleshwar. You can explore the beautiful hill station at your own pace with our comfortable taxis and flexible packages."
    },
    {
        "name": "Pune to Mahabaleshwar Car Package",
        "description": "Morya Cab offers exclusive car packages for your Pune to Mahabaleshwar journey. Choose a package that suits your schedule and enjoy a comfortable ride while visiting the famous tourist attractions in Mahabaleshwar."
    },
    {
        "name": "Pune to Mahabaleshwar Cab Service",
        "description": "Whether you're traveling for a quick getaway or a longer stay, Morya Cab provides reliable and comfortable Pune to Mahabaleshwar cab services. We ensure a smooth, safe, and enjoyable ride, making your trip memorable."
    },
    {
        "name": "Contact Information for Pune to Mahabaleshwar Cab Services",
        "description": "For more information or to book your cab, contact Morya Cab at +91 9371304510. We offer the best cab services with punctuality, comfort, and professionalism. Book your Pune to Mahabaleshwar cab today and enjoy a hassle-free journey!"
    }
]

,



tableData: [
    ["Pune to Mahabaleshwar Cab Booking", "-Taxi from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Car Hire", "-Pune to Mahabaleshwar taxi service"],
    ["Pune to Mahabaleshwar Cab Rental", "-Pune to Mahabaleshwar Elphinstone Point Car"],
    ["Pune to Mahabaleshwar Pratapgad Fort car", "-Pune to Mahabaleshwar Cab Price"],
    ["Pune to Mahabaleshwar 2 days taxi fare", "-Book cab from Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Cabs", "-Pune to Mahabaleshwar Taxi"],
    ["Pune to Mahabaleshwar cab price", "-Pune to Mahabaleshwar distance by taxi fare"],
    ["Pune to Mahabaleshwar cab for 2 days", "-Pune to Mahabaleshwar Car Package"],
    ["Pune to Mahabaleshwar cab service", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "Morya Cab ensures a hassle-free and timely journey from Pune to Mahabaleshwar. Whether it's a relaxing getaway or a family vacation, we make sure you reach your destination without delay, so you can enjoy the scenic beauty of Mahabaleshwar with peace of mind."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a range of well-maintained vehicles, including sedans, SUVs, and premium cars, all designed to provide a smooth, comfortable, and spacious ride for your Pune to Mahabaleshwar journey. Enjoy air conditioning, cozy seating, and a relaxing atmosphere throughout your trip."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly experienced in handling long-distance trips and are familiar with the best routes to Mahabaleshwar. They ensure a safe, smooth, and pleasant journey, keeping your comfort and safety as their top priorities."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive and transparent pricing, with no hidden charges. You will receive a detailed breakdown of your fare upfront, ensuring you know exactly what to expect, without any surprises along the way."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. Our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable ride throughout your Pune to Mahabaleshwar trip."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you're planning an early morning departure or a late-night return from Mahabaleshwar, Morya Cab is available around the clock. Our customer support team is always ready to assist you with bookings and other queries at any time."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your Pune to Mahabaleshwar cab is easy and quick! You can book through our website, mobile app, or contact our customer service team for assistance with personalized requests. We aim to make the booking process smooth and convenient for you."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you’re traveling for a relaxing vacation, a family trip, or a special occasion, Morya Cab offers customized travel packages to suit your preferences. Let us know your requirements, and we’ll tailor the trip to make it even more memorable."
    }
]













    }

    const faqData = [
        {
          question: "How can I book a Pune to Mahabaleshwar cab with Morya Cab?",
          answer: "You can easily book a cab through our website, mobile app, or contact our customer service team for any specific assistance or requests."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, all of our drivers are highly experienced and familiar with the Pune to Mahabaleshwar route, ensuring a smooth and safe journey."
        },
        {
          question: "What types of vehicles are available for Pune to Mahabaleshwar travel?",
          answer: "We offer a variety of vehicles, including sedans, SUVs, and premium cars, all designed for a comfortable ride with ample space for luggage and passengers."
        },
        {
          question: "How do I pay for my Pune to Mahabaleshwar cab rental?",
          answer: "We offer multiple payment options, including cash, credit/debit cards, and online payment via our app, making payment convenient and hassle-free."
        },
        {
          question: "Can I book a round trip from Pune to Mahabaleshwar?",
          answer: "Yes! We offer round trip bookings. Just provide us with your return details, and we’ll take care of everything for you."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "If there are any additional charges, such as waiting time or detours, these will be clearly communicated to you upfront, ensuring complete transparency in pricing."
        },
        {
          question: "Can I hire a taxi for sightseeing in Mahabaleshwar?",
          answer: "Yes, we offer sightseeing packages in Mahabaleshwar! Explore the famous spots like Venna Lake, Arthur’s Seat, and more, with the assistance of our experienced drivers."
        },
        {
          question: "What is the luggage allowance for a Pune to Mahabaleshwar taxi?",
          answer: "Our vehicles comfortably accommodate standard luggage. If you have more luggage or specific requirements, please inform us during booking, and we’ll make the necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel between Pune and Mahabaleshwar?",
          answer: "Yes, we provide corporate travel services for business trips, meetings, and group transport between Pune and Mahabaleshwar."
        },
        {
          question: "Why should I choose Morya Cab for my Pune to Mahabaleshwar trip?",
          answer: "Morya Cab ensures a comfortable, safe, and affordable journey with experienced drivers, well-maintained vehicles, and exceptional customer service, making us the ideal choice for your Pune to Mahabaleshwar trip."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Prakash Joshi',
          role: 'Traveller',
          review: 'We had an amazing experience with Morya Cab for our trip to Mahabaleshwar. The vehicle was spacious and clean, and the driver was very polite and knowledgeable about the route. The journey was comfortable, and we’ll definitely use Morya Cab again.',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Neelam Deshmukh',
          role: 'Family Traveller',
          review: 'Our family hired Morya Cab for a weekend getaway to Mahabaleshwar. The driver was friendly, and the vehicle was well-maintained. We enjoyed every bit of the trip, and the drive was smooth and safe. Highly recommend!',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
            
            
            
      











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];


   
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Cabs",
  "image": "https://moryacab.com/assets/images/pune-to-mahabaleshwar-cabs.jpg",
  "description": "Hire Pune to Mahabaleshwar taxi service with Morya Cab. Affordable fares, verified drivers, clean vehicles, and multiple options including Sedan, SUV, Innova Crysta, and Tempo Traveller. Perfect for family trips, group travel, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Morya Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "6812"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://moryacab.com/pune-to-mahabaleshwar-cabs"
  }
};








    return (
        <div>
            <UsePageTracking/>
<Helmet>
  <title>Pune to Mahabaleshwar Cabs | Affordable Taxi & Car Rental – Morya Cab</title>
  <meta
    name="description"
    content="Book Pune to Mahabaleshwar cabs with Morya Cab. Clean AC cars, professional drivers & transparent pricing. Choose from Sedan, SUV, Innova Crysta & Tempo Traveller for a safe and comfortable journey."
  />
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar cab, Pune to Mahabaleshwar taxi, Pune to Mahabaleshwar car rental, Pune to Mahabaleshwar Innova cab, Pune to Mahabaleshwar SUV, Pune to Mahabaleshwar one way cab, Pune to Mahabaleshwar round trip taxi, Pune to Mahabaleshwar outstation cab, Pune airport to Mahabaleshwar cab, Morya Cab Pune to Mahabaleshwar"
  />
  <link rel="canonical" href="https://moryacab.com/pune-to-mahabaleshwar-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Pune to Mahabaleshwar Cabs | Affordable Taxi & Car Rental – Morya Cab" />
  <meta property="og:description" content="Hire Pune to Mahabaleshwar cabs with Morya Cab. Enjoy safe rides with AC Sedan, SUV, Innova Crysta & Tempo Traveller at the best rates." />
  <meta property="og:url" content="https://moryacab.com/pune-to-mahabaleshwar-cabs" />
  <meta property="og:image" content="https://moryacab.com/assets/images/pune-to-mahabaleshwar-cabs.jpg" />
  <meta name="twitter:card" content="summary_large_image" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Punetomahabaleshwer;